const flags = {
  prod: true,
  socialSite: false,
  allowCreateAccount: false
};

export { flags as default };